import { Step } from "react-joyride";

/**
 * Guided tour steps for the Panel Meeting modal.
 *
 * Each step targets a `data-testid` attribute rendered in the modal.
 * If a target isn't present (e.g. consensus panel hidden on the "overall"
 * view), Joyride will auto-skip it.
 */
export const panelMeetingSteps: Step[] = [
	{
		target: '[data-testid="criteria-nav"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Criteria Navigation</h3>
				<p>
					Use this bar to move between criteria. Each criterion shows a tick
					when its consensus score has been entered for all suppliers.
				</p>
				<p className="mt-2 text-gray-500">
					Click <strong>Scores and Award</strong> at the end to view overall
					results and set award decisions.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="score-comparison-table"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Score Comparison</h3>
				<p>
					This table shows each panel member&apos;s score per supplier.
					Hover over any cell to highlight the row and column — useful for
					discussing specific scores in the meeting.
				</p>
				<p className="mt-2 text-gray-500">
					Click a member&apos;s speech bubble to view their comments.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="view-current-scores"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Current Scores</h3>
				<p>
					Click here to see a summary of all supplier scores — both the
					pre-meeting averages and the current consensus scores — in one
					table. Useful for checking overall progress without leaving the
					current criterion.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="toggle-scoring-guide"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Scoring Guide</h3>
				<p>
					Toggle this to open the scoring guide panel. It highlights the
					relevant score range as you hover over cells or enter consensus
					scores, so the panel can reference the rubric during discussion.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="consensus-panel-scroll"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Consensus Scores</h3>
				<p>
					Enter the agreed consensus score and any panel notes for each
					supplier here. Scores auto-save as you type.
				</p>
				<p className="mt-2 text-gray-500">
					Use the <strong>Use Avg</strong> button to pre-fill with the
					panel average if the group agrees.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
	{
		target: '[data-testid="complete-meeting-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Complete Meeting</h3>
				<p>
					Once all criteria have a consensus score, click here to finalise the
					meeting and proceed to the award decision step.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
];
